/**
 * @generated SignedSource<<5cc4c8aaf420d1b6d1a6c2f8f96ad227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type locationStateActionItemLinkQuery$variables = {
  originatingNoteId: string;
};
export type locationStateActionItemLinkQuery$data = {
  readonly node: {
    readonly stream?: {
      readonly displayName: string;
      readonly id: string;
    };
  } | null;
};
export type locationStateActionItemLinkQuery = {
  response: locationStateActionItemLinkQuery$data;
  variables: locationStateActionItemLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "originatingNoteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "originatingNoteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "locationStateActionItemLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "locationStateActionItemLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "37a09833689e5d8113243844f47a38cb",
    "id": null,
    "metadata": {},
    "name": "locationStateActionItemLinkQuery",
    "operationKind": "query",
    "text": "query locationStateActionItemLinkQuery(\n  $originatingNoteId: ID!\n) {\n  node(id: $originatingNoteId) {\n    __typename\n    ... on Note {\n      stream {\n        id\n        displayName\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d53069f51e4552290421abedbf68d20f";

export default node;
